var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AsurionDiv } from '../BaseComponents';
import { Tooltip } from 'react-tooltip';
import { CardBrandUrlPath, InlineMaxCardsMedium } from '../../common/Constants';
import { ScreenWidths, InlineMaxCardsLarge, InlineMaxCardsSmall, TooltipRowMaxCards } from '../../common/Constants';
var OverflowCard = styled(AsurionDiv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 38px;\n    height: 24px;\n    box-sizing: border-box;\n    border: 1px solid #e6e6eb;\n    border-radius: 3px;\n    background: white;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n"], ["\n    width: 38px;\n    height: 24px;\n    box-sizing: border-box;\n    border: 1px solid #e6e6eb;\n    border-radius: 3px;\n    background: white;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n"])));
var OverflowTooltip = styled(Tooltip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    opacity: 1;\n"], ["\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    opacity: 1;\n"])));
var TooltipRow = styled(AsurionDiv)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    align-items: center;\n    justify-content: start;\n    display: flex;\n    gap: 4px;\n    opacity: 1;\n"], ["\n    align-items: center;\n    justify-content: start;\n    display: flex;\n    gap: 4px;\n    opacity: 1;\n"])));
var OverflowLabel = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 14px;\n    color: black;\n    white-space: nowrap;\n    overflow: hidden;\n"], ["\n    font-size: 14px;\n    color: black;\n    white-space: nowrap;\n    overflow: hidden;\n"])));
var CreditCardBrandsWrapper = styled(AsurionDiv)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 0;\n    flex-shrink: 0;\n    gap: 4px;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-grow: 0;\n    flex-shrink: 0;\n    gap: 4px;\n    align-items: center;\n"])));
var CardLogo = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\nstyle=", ""], ["\nstyle=", ""])), {
    width: '38px',
    height: '24px',
    objectFit: 'cover',
    border: '1px solid #e6e6eb',
    boxSizing: 'border-box',
    borderRadius: '3px'
});
var getScreenWidth = function () {
    var _a = useState({
        width: window.innerWidth,
        height: window.innerHeight
    }), screenSize = _a[0], setScreenSize = _a[1];
    useEffect(function () {
        var handleResize = function () {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener('resize', handleResize);
        // Clean up the event listener when the component unmounts
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return screenSize.width;
};
export var CreditCardBrands = function (props) {
    var _a;
    var supportedCards = useMemo(function () { return (props === null || props === void 0 ? void 0 : props.supportedCards) || []; }, [props.supportedCards]);
    var screenWidth = getScreenWidth();
    if (!(props === null || props === void 0 ? void 0 : props.supportedCards) || !((_a = props.supportedCards) === null || _a === void 0 ? void 0 : _a.length)) {
        return (React.createElement(CreditCardBrandsWrapper, { id: props.id },
            "(",
            React.createElement(React.Fragment, null),
            ")"));
    }
    if (props === null || props === void 0 ? void 0 : props.invalidCardBrand) {
        return (React.createElement(CreditCardBrandsWrapper, { id: props.id },
            React.createElement(CardLogo, { loading: 'lazy', src: "".concat(CardBrandUrlPath, "nocard.svg"), alt: 'nocard', key: 'nocard' })));
    }
    var inlineMaxCards = InlineMaxCardsLarge;
    if (screenWidth < ScreenWidths.Tablet_520) {
        inlineMaxCards = InlineMaxCardsMedium;
    }
    if (screenWidth < ScreenWidths.Phone_412) {
        inlineMaxCards = InlineMaxCardsSmall;
    }
    var supportedCardComponents = [];
    for (var _i = 0, supportedCards_1 = supportedCards; _i < supportedCards_1.length; _i++) {
        var cardType = supportedCards_1[_i];
        if (props.selectedCard === undefined || props.selectedCard === cardType) {
            var imgTag = (React.createElement(CardLogo, { loading: 'lazy', 
                // crossOrigin='use-credentials'
                src: "".concat(CardBrandUrlPath).concat(cardType, ".svg"), alt: cardType, key: cardType }));
            supportedCardComponents.push(imgTag);
        }
    }
    // split cards into two groups: inline and overflow(tooltip)
    var inlineCards = supportedCardComponents.slice(0, inlineMaxCards);
    var overflowCards = supportedCardComponents.slice(inlineMaxCards);
    if (overflowCards.length > 0) {
        // display tooltip cards in rows of 3
        var toolTipId = 'cardBrandsOverflowTooltip';
        var tooltipRowsCount = overflowCards.length / TooltipRowMaxCards;
        var tooltipRows = [];
        // DO NOT CHANGE `tooltipRowsCount - i > 0` to `i < tooltipRowsCount`
        // tooltipRowsCount might have trailing decimals and that is important to this logic
        for (var i = 0; tooltipRowsCount - i > 0; i++) {
            var start = i * TooltipRowMaxCards;
            var end = TooltipRowMaxCards * (i + 1);
            tooltipRows.push(React.createElement(TooltipRow, { key: "toolTipRowKey".concat(i) }, overflowCards.slice(start, end)));
        }
        inlineCards.push(React.createElement("div", { key: 'brandWithOverflowKey' },
            React.createElement(OverflowCard, { "data-tooltip-id": toolTipId, "data-tooltip-place": 'top-end' },
                React.createElement(OverflowLabel, null, "+".concat(overflowCards.length))),
            React.createElement(OverflowTooltip, { id: toolTipId, children: tooltipRows })));
    }
    return React.createElement(CreditCardBrandsWrapper, { id: props.id }, inlineCards);
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
